import { useMemo } from 'react';

const USA_PHONE_CODE = '+1';
const INAPPROPRIATE_PHONE_PARTS_REGEX = /[^+\d]/g;
const PHONE_GROUPS_REGEX = /(^\+1)(\d{0,3})(\d{0,3})(\d{0,4})/;

const getRealPhone = (phone: string) => phone.replace(INAPPROPRIATE_PHONE_PARTS_REGEX, '');

export function usePhoneMask(input: string | null) {
  const getMaskedPhone = useMemo(() => {
    if (!input || input.length <= 1) {
      return `${USA_PHONE_CODE} `;
    }

    const groups = (input.startsWith(USA_PHONE_CODE) ? input : `${USA_PHONE_CODE}${input}`)
      .replace(INAPPROPRIATE_PHONE_PARTS_REGEX, '')
      .match(PHONE_GROUPS_REGEX);

    const countryCode = groups?.[1];
    const specificCode = groups?.[2];
    const firstPart = groups?.[3];
    const secondPart = groups?.[4];

    if (!countryCode) return;
    if (!specificCode) return `${countryCode} `;
    if (!firstPart) return `${countryCode} (${specificCode}`;

    return `${countryCode} (${specificCode}) ${firstPart}${secondPart ? `-${secondPart}` : secondPart}`;
  }, [input]);

  return {
    getMaskedPhone,
    getRealPhone,
    maskedMaxPhoneLength: 17,
  };
}
